/** ATC to quantity selector - Plum Goodness */
(function () {

  // ============================================================
  // INSTANT HIDER
  // Hides qty inputs the moment they are inserted into DOM
  // ============================================================

  const hiddenWrappers = new WeakSet();

  function hideAllQtyInputs(root) {
    root.querySelectorAll('.product-item__cta-wrapper').forEach(wrapper => {
      if (hiddenWrappers.has(wrapper)) return;
      hiddenWrappers.add(wrapper);
      wrapper.querySelectorAll('.qty-input').forEach(qi => {
        qi.setAttribute('style', 'display:none!important');
      });
    });
  }

  hideAllQtyInputs(document);

  new MutationObserver(mutations => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.classList?.contains('qty-input')) {
          node.setAttribute('style', 'display:none!important');
        }
        node.querySelectorAll?.('.qty-input').forEach(qi => {
          qi.setAttribute('style', 'display:none!important');
        });
        hideAllQtyInputs(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ============================================================
  // CART CACHE
  // ============================================================

  let cachedCart = null;

  async function getCart(force = false) {
    if (cachedCart && !force) return cachedCart;
    const res = await fetch('/cart.js');
    cachedCart = await res.json();
    return cachedCart;
  }

  function updateCache(cartData) {
    cachedCart = cartData;
  }

  // ============================================================
  // FIRE THEME EVENTS
  // ============================================================

  async function fireCartEvents(cartData) {
    let cart = cartData;

    if (cart.item_count === undefined) {
      cart = await getCart(true);
    } else {
      updateCache(cart);
    }

    // bubbles: false — hits only the exact target, no double-firing
    [document, document.documentElement, document.body].forEach(target => {
      target.dispatchEvent(new CustomEvent('cart:updated', { bubbles: false, detail: { cart } }));
      target.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: false, detail: { cart, openMiniCart: false } }));
     // target.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: false, detail: { cart, openMiniCart: true } }));
    });
  }

  // ============================================================
  // FORM HELPERS
  // ============================================================

  function getWrapperIds(wrapper) {
    const form = wrapper.querySelector('form');
    if (!form) return { variantId: null, productId: null };
    const variantId = String(form.querySelector('input[name="id"]')?.value || '').trim();
    const productId = String(form.querySelector('input[name="product-id"]')?.value || '').trim();
    return { variantId, productId };
  }

  function updateFormVariantId(wrapper, newVariantId) {
    const idInput = wrapper.querySelector('form input[name="id"]');
    if (idInput) idInput.value = String(newVariantId);
  }

  // ============================================================
  // UI HELPERS
  // ============================================================

  function getVisibleQtyInput(wrapper) {
    const all = wrapper.querySelectorAll('.qty-input');
    return all.length > 0 ? all[all.length - 1] : null;
  }

  function showQtySelector(wrapper, qty) {
    wrapper.querySelectorAll('.qty-input').forEach(qi => {
      qi.setAttribute('style', 'display:none!important');
    });

    const qtyInput = getVisibleQtyInput(wrapper);
    const atcBtn   = wrapper.querySelector('button[type="submit"]');

    if (qtyInput) qtyInput.setAttribute('style', 'display:flex!important');
    if (atcBtn)   atcBtn.setAttribute('style', 'display:none!important');
    if (qty != null) setQtyValue(wrapper, qty);
  }

  function showATCButton(wrapper) {
    wrapper.querySelectorAll('.qty-input').forEach(qi => {
      qi.setAttribute('style', 'display:none!important');
    });

    const atcBtn = wrapper.querySelector('button[type="submit"]');
    if (!atcBtn) return;

    // Restore original HTML if spinner is showing
    if (atcBtn.querySelector('.atc-spinner')) {
      atcBtn.innerHTML = atcBtn.dataset.originalHtml || 'Add to cart';
      atcBtn.disabled  = false;
    }

    atcBtn.setAttribute('style', '');
  }

  function getQtyValue(wrapper) {
    const qtyInput = getVisibleQtyInput(wrapper);
    if (!qtyInput) return 0;
    const input = qtyInput.querySelector('.qty-input__input');
    return input ? parseInt(input.value, 10) || 0 : 0;
  }

  function setQtyValue(wrapper, val) {
    const qtyInput = getVisibleQtyInput(wrapper);
    if (!qtyInput) return;
    const input = qtyInput.querySelector('.qty-input__input');
    if (input) input.value = val;
  }

  function setLoading(wrapper, loading) {
    wrapper.querySelectorAll('button').forEach(btn => btn.disabled = loading);
    wrapper.style.opacity       = loading ? '0.6' : '';
    wrapper.style.pointerEvents = loading ? 'none'  : '';
  }

  // ============================================================
  // CART SYNC
  // ============================================================

  function syncWrapperWithCart(wrapper, cart) {
    const { variantId, productId } = getWrapperIds(wrapper);
    if (!variantId && !productId) { showATCButton(wrapper); return; }

    let cartItem = cart.items.find(i => String(i.variant_id) === variantId);

    if (!cartItem && productId) {
      cartItem = cart.items.find(i => String(i.product_id) === productId);
      if (cartItem) updateFormVariantId(wrapper, cartItem.variant_id);
    }

    cartItem?.quantity > 0 ? showQtySelector(wrapper, cartItem.quantity) : showATCButton(wrapper);
  }

  // ============================================================
  // VARIANT SWATCH CHANGE
  // ============================================================

  function handleVariantSwatchChange(wrapper) {
    const productItem = wrapper.closest('product-item');
    if (!productItem) return;

    productItem.querySelectorAll('.color-swatch__radio').forEach(radio => {
      radio.addEventListener('change', async () => {
        const newVariantId = radio.dataset.variantId;
        if (!newVariantId) return;

        updateFormVariantId(wrapper, newVariantId);

        // Instantly show correct UI from cache
        if (cachedCart) {
          const cachedItem = cachedCart.items.find(i => String(i.variant_id) === String(newVariantId));
          cachedItem?.quantity > 0 ? showQtySelector(wrapper, cachedItem.quantity) : showATCButton(wrapper);
        }

        // Silently verify with fresh cart
        const freshCart = await getCart(true);
        const cartItem  = freshCart.items.find(i => String(i.variant_id) === String(newVariantId));
        cartItem?.quantity > 0 ? showQtySelector(wrapper, cartItem.quantity) : showATCButton(wrapper);
      });
    });
  }

  // ============================================================
  // HANDLERS
  // ============================================================

  async function handleATCClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const wrapper       = e.currentTarget.closest('.product-item__cta-wrapper');
    const { variantId } = getWrapperIds(wrapper);
    if (!variantId) return;

    const atcBtn = wrapper.querySelector('button[type="submit"]');
    if (!atcBtn.dataset.originalHtml) {
      atcBtn.dataset.originalHtml = atcBtn.innerHTML;
    }

    atcBtn.innerHTML = '<span class="atc-spinner"></span>';
    atcBtn.disabled  = true;

    const grammage = wrapper.querySelector('[name="properties[grammage]"]')?.value || "";
      try {
        const res  = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              item_category: wrapper.querySelector('[name="properties[item_category]"]')?.value || "",
              item_category2: wrapper.querySelector('[name="properties[item_category2]"]')?.value || "",
              item_category3: wrapper.querySelector('[name="properties[item_category3]"]')?.value || "",
              ...(grammage ? { grammage } : {})
              
            }
          })
        });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || res.status);

      // Dispatch the 'variant:added' event with full variant information
      document.dispatchEvent(new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: data.hasOwnProperty("items") ? data["items"][0] : data
        }
      }));

      showQtySelector(wrapper, 1);
      fireCartEvents(data);
    } catch (err) {
      console.error('[CartSync] add error:', err);
      atcBtn.innerHTML = atcBtn.dataset.originalHtml;
      atcBtn.disabled  = false;
      alert(err.message || 'Could not add to cart.');
    }
  }

  async function handlePlusClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const wrapper       = e.currentTarget.closest('.product-item__cta-wrapper');
    const { variantId } = getWrapperIds(wrapper);
    const grammage = wrapper.querySelector('[name="properties[grammage]"]')?.value || "";

    const currentQty    = getQtyValue(wrapper);
    
    setLoading(wrapper, true);
    setQtyValue(wrapper, currentQty + 1);
    try {
      const res  = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
         body: JSON.stringify({
              id: variantId,
              quantity: 1,
              
              properties: {
                item_category: wrapper.querySelector('[name="properties[item_category]"]')?.value || "",
                item_category2: wrapper.querySelector('[name="properties[item_category2]"]')?.value || "",
                item_category3: wrapper.querySelector('[name="properties[item_category3]"]')?.value || "",
                ...(grammage ? { grammage } : {})
              }
            })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || res.status);
      // Dispatch the 'variant:added' event with full variant information
      document.dispatchEvent(new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: data.hasOwnProperty("items") ? data["items"][0] : data
        }
      }));
      fireCartEvents(data);
    } catch (err) {
      console.error('[CartSync] plus error:', err);
      setQtyValue(wrapper, currentQty);
    } finally {
      setLoading(wrapper, false);
    }
  }

  async function handleMinusClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const wrapper       = e.currentTarget.closest('.product-item__cta-wrapper');
    const { variantId } = getWrapperIds(wrapper);
    const currentQty    = getQtyValue(wrapper);
    const newQty        = currentQty - 1;

    setLoading(wrapper, true);

    try {
      const freshCart = await getCart(true);
      const cartItem  = freshCart.items.find(i => String(i.variant_id) === String(variantId));
      const line      = cartItem ? freshCart.items.indexOf(cartItem) + 1 : null;
      if (!line) throw new Error('Item not found in cart');

      const res  = await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body:    JSON.stringify({ line, quantity: newQty <= 0 ? 0 : newQty })
      }); 
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || res.status);

      newQty <= 0 ? showATCButton(wrapper) : setQtyValue(wrapper, newQty);
      fireCartEvents(data);
    } catch (err) {
      console.error('[CartSync] minus error:', err);
      setQtyValue(wrapper, currentQty);
    } finally {
      setLoading(wrapper, false);
    }
  }


  document.addEventListener('cart:updated', function (event) {
    const cart = event.detail.cart;

    document.querySelectorAll('.product-item__cta-wrapper').forEach(wrapper => {
      syncWrapperWithCart(wrapper, cart);
    });
  });

  // ============================================================
  // INIT
  // ============================================================

  function initWrapper(wrapper, cart) {
    syncWrapperWithCart(wrapper, cart);
    if (wrapper.dataset.cartSyncInit === 'true') return;
    wrapper.dataset.cartSyncInit = 'true';

    const atcBtn = wrapper.querySelector('button[type="submit"]');
    if (atcBtn) atcBtn.addEventListener('click', handleATCClick);

    wrapper.querySelectorAll('[name="plus"]').forEach(btn => btn.addEventListener('click', handlePlusClick));
    wrapper.querySelectorAll('[name="minus"]').forEach(btn => btn.addEventListener('click', handleMinusClick));

    handleVariantSwatchChange(wrapper);
  }

  async function init() {
    const cart = await getCart(true);
    document.querySelectorAll('.product-item__cta-wrapper').forEach(w => initWrapper(w, cart));

    // Watch for dynamically added sections
    new MutationObserver(mutations => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          const wrappers = [];
          if (node.matches?.('.product-item__cta-wrapper')) wrappers.push(node);
          node.querySelectorAll?.('.product-item__cta-wrapper').forEach(w => wrappers.push(w));
          if (wrappers.length > 0) {
            getCart(true).then(freshCart => wrappers.forEach(w => initWrapper(w, freshCart)));
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
/** end ATC to quantity selector */



